import React,{useState} from 'react';
import BarChartGeneric from './BarChartGeneric';
import { ALL_METRICS } from '../../constants/constantsAnalytic';

const BarChartTONandA = (props) => {
  const t = (key, fallback) => {
    const value = typeof props.translate === 'function' ? props.translate(key) : key;
    return value && value !== key ? value : fallback;
  };

  const toggleLabels = ALL_METRICS
    .filter(metric => props?.alarmGraph?.includes(metric.key))
    .map((metric, i) => ({
      field: metric.key,
      label: metric.key === 'alarms_count'
        ? t('alarms', 'Alarmas')
        : metric.key === 'alarms_by_visits'
          ? t('alarms_per_visit', 'Alarmas por visita')
          : t('alarms_per_ton', 'Alarmas por tonelada'),
      activeColor: metric.color,
      inactiveColor: metric.inactiveColor,
      axis: i === 0 ? 'left' : 'right',
      isLine: metric.key === 'alarms_by_ton',
    }));

  const handleContextMenu = (e, field) => {
    e.preventDefault();
    e.stopPropagation();
    if (field !== 'alarms_by_ton' && field !== 'alarms_by_visits') {
      return; // No hacer nada si no coincide
    }

    if (field === 'alarms_by_ton') {
      // Cambia a Alarmas / Visitas + Alarmas
      props.setAlarmGraph(['alarms_count','alarms_by_visits']);
    } else if (field === 'alarms_by_visits') {
      // Regresa a Alarmas / Ton + Alarmas
      props.setAlarmGraph(['alarms_count','alarms_by_ton']);
    }
  };
  return (
    <BarChartGeneric 
      {...props}
      toggleLabels={toggleLabels}
      handleContextMenu={handleContextMenu}
      alarmGraph={props.alarmGraph}
      // alarmGraph2={props.alarmGraph}
      key={props?.alarmGraph?.join(',')} 
    />
  );
};

export default BarChartTONandA;
